import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const dataAutomation = {
    container: generateAutomationName("settings", ["viewerMode", "container"]),
};
